module.exports = __webpack_public_path__ + "img/icea_lion.a05f8265.jpg";